export default "__VITE_ASSET__CwH3xH9r__"